import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('intelligentOutboundCallDetailsStore')
@observer
class IntelligentOutboundCallDetails extends Component {
  render() {
    const { intelligentOutboundCallDetailsStore, location } = this.props
    const { isFetching } = intelligentOutboundCallDetailsStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default IntelligentOutboundCallDetails;
